import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { UsuarioModel } from '../../models/user-model';
import { IdentityApiService } from './identity-api.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private readonly currentUserSubject = new BehaviorSubject<UsuarioModel | null>(null);

  constructor(private identityApiService: IdentityApiService) { }

  currentUser$ = this.currentUserSubject.asObservable();

  getCurrentUserSnapshot(): UsuarioModel | null {
    return this.currentUserSubject.value;
  }

  setCurrentUser(user: UsuarioModel | null) {
    this.currentUserSubject.next(user);
  }

  clearCurrentUser() {
    this.currentUserSubject.next(null);
  }

  loadCurrentUser(forceRefresh: boolean = false): Observable<UsuarioModel | null> {
    const cachedUser = this.currentUserSubject.value;

    if (!forceRefresh && cachedUser) {
      return of(cachedUser);
    }

    return this.identityApiService.getDadosUsuario().pipe(
      tap((user) => this.currentUserSubject.next(user))
    );
  }

  updateCurrentUser(dados: UsuarioModel): Observable<UsuarioModel> {
    return this.identityApiService.atualizarDadosUsuario(dados).pipe(
      tap((user) => this.currentUserSubject.next(user))
    );
  }
}
